import { Injectable, signal } from "@angular/core";
import { Haptics, NotificationType } from "@capacitor/haptics";
import { HapticsProvider, HapticType } from "./haptics.provider";

@Injectable({ providedIn: 'root' })
export class ScreenAnimationProvider {
    public isWave = signal<boolean>(false);
    public isShake = signal<boolean>(false);
    public isSwipeLeft = signal<boolean>(false);
    public wasSwipeLeft = signal<boolean>(false);

    public isSwipeDown = signal<boolean>(false);
    public wasSwipeDown = signal<boolean>(false);

    private shakeTimeout: any;
    private waveTimeout: any;

    constructor(private hapticsProvider: HapticsProvider) { }

    shake() {
        this.isShake.set(false);
        clearTimeout(this.shakeTimeout);
        this.isShake.set(true);
        Haptics.notification({ type: NotificationType.Error });
        this.shakeTimeout = setTimeout(() => this.isShake.set(false), 400);
    }

    async wave() {
        this.isWave.set(false);
        clearTimeout(this.waveTimeout);
        this.hapticsProvider.vibrate(HapticType.Click);
        this.isWave.set(true);
        this.waveTimeout = setTimeout(() => this.isWave.set(false), 600);
    }

    swipeLeft() {
        this.wasSwipeLeft.set(true);
        this.isSwipeLeft.set(true);
    }

    restoreSwipeLeft() {
        this.isSwipeLeft.set(false);
        setTimeout(() => this.wasSwipeLeft.set(false), 200);
    }

    swipeDown() {
        this.wasSwipeDown.set(true);
        this.isSwipeDown.set(true);
    }

    restoreSwipeDown() {
        this.isSwipeDown.set(false);
        setTimeout(() => this.wasSwipeDown.set(false), 400);
    }
}